<template>
  <div class="">
    <v-simple-table dense fixed-header height="400px" v-if="list.length > 0">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="">{{ $t("DDATE") }}</th>
            <th class="">{{ $t("DayName") }}</th>
            <th class="">{{ $t("totalKasrKar") }}</th>
            <th class="">{{ $t("EXTRAWORKTOTAL") }}</th>
            <th class="">{{ $t("Morakhasi") }}</th>
            <th class="">{{ $t("MISSION") }}</th>
            <th class="">{{ $t("WORKTOTAL") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in list"
            :key="index"
            :class="statusClass(item)"
            class="text-color-black"
            @click="onClickItem(item)"
          >
            <td>{{ item.DDATE }}</td>
            <td>{{ item.DayName }}</td>
            <td>{{ item.totalKasrKar }}</td>
            <td>{{ item.EXTRAWORKTOTAL }}</td>
            <td>{{ item.Morakhasi }}</td>
            <td>{{ item.MISSION }}</td>
            <td>{{ item.WORKTOTAL }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  methods: {
    statusClass(item) {
      var classList = [];
      if (Number(item.HOLIDAY) > 0) {
        classList.push("holiday");
      } else if (Number(item.DAILYABSENCE) > 0) {
        classList.push("absent");
      } else {
        classList.push("normal");
      }
      return classList;
    },
    onClickItem(item){
      this.$emit('onClickItem',item)
    }
  },
};
</script>

<style>

</style>